<template>
    <div id="subOutputRank-print" class="page-break">
        <el-row>
            <el-col :span="12" :offset="6">
                <!-- <h1 style="text-align: center;margin-top: 0;padding-top: 0;color: #000">{{printTitle}}</h1> -->
                <h1 style="text-align: center;margin-top: 0;padding-top: 0;color: #000"> {{ this.companyName }}采购单</h1>
            </el-col>
        </el-row>
        <el-row>
            <el-col v-if="topData.length > 0" :span="9">
                <ul>
                    <li>供&nbsp;&nbsp;应&nbsp;&nbsp;商：{{topData[0].SUPPLIER_NAME}}</li>
                    <li>订&nbsp;单&nbsp;编号：{{topData[0].ORDER_CODE}}</li>
                </ul>
            </el-col>
            <el-col :span="12" style="padding-left: 70px">
                <ul>
                    <li></li>
                    <li>送&nbsp;货&nbsp;日&nbsp;期：{{topData[0].SEND_DAY}}</li>
                </ul>
            </el-col>
        </el-row>
        <el-row>
            <el-col :span="24">
                <table style="width: 100%">
                    <tr>
                        <th style="width: 5%">序号</th>
                        <th style="width: 40%">名称</th>
                        <th style="width: 5%">单位</th>
                        <th style="width: 10%">单价</th>
                        <th style="width: 10%">订购</th>
                        <th style="width: 10%">实收</th>
                        <th style="width: 15%">备注</th>
                    </tr>
                    <tr v-for = "(item,index) in mainData[0]" :key="index">
                        <td>{{item.ID}}</td>
                        <td>{{item.PRODUCT_NAME}}</td>
                        <td>{{item.TYPE_UNIT}}</td>
                        <td>{{item.GYS_PRICE}}</td>
                        <td>{{item.PRODUCT_COUNT}}</td>
                        <td>{{item.REAL_COUNT}}</td>
                        <td>{{item.PRODUCT_COMMENT}}</td>
                    </tr>
                </table>
            </el-col>
        </el-row>
          <el-row>

            <!-- <el-col :span="6">
                <p>制单人：</p>
            </el-col>
            <el-col :span="6">
                <p>验收人：</p>
            </el-col>
            <el-col :span="6">
                <p>确认人：</p>
            </el-col>
            <el-col :span="6">
                <p>审核人：</p>
            </el-col> -->
             <el-col :span="6">
                <p>制单人：{{this.下单人名称}}</p>
            </el-col>
            <el-col :span="6">
                <p>采购员：</p>
            </el-col>
            <el-col :span="6">
                <p>审批人：</p>
            </el-col>
            <el-col :span="6">
                <p>审核人：</p>
            </el-col>
        </el-row>

        <el-row>
            <el-col :span="3" :offset="21" style="padding: 0">
                <p>第{{mainData[0].currentPage}}页/共{{mainData[0].totalPage}}页</p>
            </el-col>
        </el-row>
    </div>
</template>
<script type="text/ecmascript-6">
export default {
  props: {
    tableData: {
      type: Array,
      default() {
        return [];
      },
      required: true,
    },
    headerData: {
      type: Array,
      default() {
        return [];
      },
      required: true,
    },
    manager: String,
    supplier: String,
    title: String,
    orderer: {
      type: String,
      default: ''
    }
  },
  data() {
    return {

      topData: [],
      mainData: [],
      managername: '',
      imgUrl: '',
      companyName: '',
      printSupplier: '',
      printTitle: '',
    };
  },
  created() {
    this.topData = this.headerData;
    this.mainData.push(this.tableData);
    this.managername = this.manager;
    this.printSupplier = this.supplier;
    this.下单人名称 = this.orderer;
    this.printTitle = this.title;
    this.companyName = sessionStorage.getItem('company');
    this.imgUrl = `https://service.linkda.com.cn/file/barcode/${this.topData[0].ORDER_ID}.png`;
    // this.imgUrl = 'http://47.99.59.146/file/barcode/'+ this.topData[0].ORDER_ID + '.png'
  },
};
</script>
<style scoped>
    ul{
        margin-top: 0;
        padding-top: 0;
        padding-left: 0;
    }
    li{
        list-style: none;
        font-size: 20px;
        line-height: 30px;
        color: #000;
        font-family: 黑体;
    }
    span{
        font-size: 20px;
        line-height: 35px;
        color: #000;
        font-family: 黑体;
    }
    table {
        border-collapse: collapse;
        width: 130%;
        border: 1px solid #000;
        font-weight: bold;
    }
    td,th {
        border: 1px solid #000;
        text-align: center;
        font-weight: normal;
        font-size: 20px;
        height: 30px;
        font-family: 黑体;
        color: #000;
    }
</style>



// WEBPACK FOOTER //
// src/components/shopOrderManage/s_priceTax.vue